/* eslint-disable import/no-anonymous-default-export */
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from '@insticator/insticator-ui'


/* ++++++++++ --------------- EXPORT : COMMENTING CONFIGURATION ADMIN SECTION : STYLES --------------- ++++++++++ */
export default theme => ({
  trendingnow: {
    width: '100%',
    maxWidth: 'auto',
    '& .articlecard': {
      minWidth: 'unset',
      width: '100%',
      height: pxToEm(160),
      '&.horizontal': {
        height: pxToEm(200)
      }
    }
  }
});
